<template>
  <div>
    <div class="d-flex align-items-center mb-2" v-if="isLoading">
      <div class="w-100">
        <b-progress
        :value="progress"
        max="100"
        show-progress
        striped
        variant="success"
        class="progress-bar-success"
      />
      </div>
    </div>
    <div>
      <div class="d-flex justify-content-between align-items-center">
        <h5>Sutün Seç</h5>
      </div>
      <v-select
        v-model="selected"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        multiple
        label="title"
        :options="option"
      />
      <div class="mt-1 d-flex justify-content-between">
          <!-- button -->
          <b-button
            size="sm"
            variant="danger"
            class="mr-1"
            @click="handleCancel"
          >
            İptal
          </b-button>
          <b-button
            size="sm"
            variant="success"
            @click="startDownload"
            :disabled="isLoading"
          >
            {{ isLoading ? 'Dosya Hazırlanıyor...' : 'İndir' }}
          </b-button>
        </div>
    </div>
    
  </div>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol,
  BProgress,
  BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/axios'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import * as XLSX from 'xlsx';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BProgress,
    BButton,

    vSelect,
  },
  data() {
    return {
      isLoading: false, // Yükleme durumu
      progress: 0, // İlerleme durumu
      error: null, // Hata mesajı
      selected: [
        { title: 'Ürün ID' },
        { title: 'Adı' },
        { title: 'Güncel Satış Fiyatı' },
        { title: 'Satış Adedi' },
      ],
      option: [
        { title: 'Ürün ID' },
        { title: 'Adı' },
        { title: 'Güncel Satış Fiyatı' },
        { title: 'Barcode' },
        { title: 'Marka' },
        { title: 'Varyant' },
        { title: 'Satış Adedi' },
        { title: 'Link İçi Satış Adedi' },
        { title: 'Link Dışı Satış Adedi' },
      ],
      columnMap : {
        'Ürün ID': 'identifier',
        'Adı': 'name',
        'Güncel Satış Fiyatı': 'base_price',
        'Barcode': 'barcode',
        'Marka': 'brand',
        'Varyant': 'variant',
        'Satış Adedi': 'sale_count',
        'Link İçi Satış Adedi': 'in_link_count',
        'Link Dışı Satış Adedi': 'out_link_count',
      }
    }
  },
  props: {
    additionalParams: {
      type: Object,
      required: false,
    },
    excelTitle: {
      type: String,
      required: false,
    },
  },
  methods: {
    handleCancel(){
      this.$emit('popoverShow', false);
    },

    async startDownload() {
      const selectedColumns = this.selected.map(item => this.columnMap[item.title]); // API için uygun sütun isimleri

      this.isLoading = true;
      this.progress = 0;
      this.error = null;


      try {
          // Axios ile veri çekme
          const response = await axiosIns({
              method: 'GET',
              url: '/product/productExcel',
              responseType: 'json',
              params: {
                  ...this.additionalParams,
                  columns: selectedColumns,
              },
              onDownloadProgress: (progressEvent) => {
                  if (progressEvent.lengthComputable) {
                      this.progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                  }
              },
          });

          if (!response.data.products || response.data.products.length === 0) {
              this.$toast.error('Geçerli veri bulunamadı.');
              throw new Error('Geçerli veri bulunamadı.');
          }

          // **Başlıkları değiştirme işlemi**
          const products = response.data.products;
          const transformedData = products.map(product => {
              let newProduct = {};
              for (let [key, value] of Object.entries(product)) {
                  // Eğer API'den gelen sütun columnMap içinde varsa, kullanıcı dostu başlığı kullan
                  const columnTitle = Object.keys(this.columnMap).find(title => this.columnMap[title] === key);
                  newProduct[columnTitle || key] = value;
              }
              return newProduct;
          });

          // Excel için JSON'u Sheet'e çevir
          const ws = XLSX.utils.json_to_sheet(transformedData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, 'Ürünler');

          // Dosyayı indir
          XLSX.writeFile(wb, this.excelTitle+'.xlsx');

          // İndirme tamamlandı
          this.progress = 100;

          
          this.$toast({
              component: ToastificationContent,
              position: 'bottom-right',
              props: {
                  icon: 'CheckIcon',
                  variant: 'success',
                  title: "İndirme işlemi başarılı",
              },
          });
      } catch (err) {
          this.$toast.error('Dosya oluşturulurken hata oluştu. Lütfen tekrar deneyin. Hata: ' + err);
          this.isLoading = false;
          this.progress = 0;
          this.$emit('popoverShow', false);
      } finally {
          setTimeout(() => {
              this.isLoading = false;
              this.progress = 0;
              this.$emit('popoverShow', false);
          }, 2000);
      }
    }

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.selected-row {
  background-color: #d1e7dd !important; /* Açık yeşil arka plan */
}
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
.per-page-selector {
  width: 90px;
}
.fixed-bottom {
  margin-bottom: 4vw; /* Toast'ın alt kısımdaki yüksekliği */
}
.text-center {
  text-align: center; /* Yazıyı ortalamak için */
}
.vs__deselect svg{
  fill: #FFF;
}
</style>